import { NotificationItem } from '@/components/navbar/NotificationItem'
import type { Notification } from '@/types'

interface NotificationListProps {
  notifications: Notification[]
  isLoading: boolean
  onSelect: (notification: Notification) => void
}

export function NotificationList({ notifications, isLoading, onSelect }: NotificationListProps) {
  return (
    <div className="max-h-80 overflow-y-auto">
      {isLoading && <div className="p-4 text-center text-muted">Loading...</div>}
      {!isLoading && notifications.length === 0 && (
        <div className="p-4 text-center text-muted">No notifications yet</div>
      )}
      {!isLoading && notifications.length > 0 && (
        <div className="divide-y divide-theme-border">
          {notifications.map((notification) => (
            <NotificationItem key={notification.id} notification={notification} onClick={onSelect} />
          ))}
        </div>
      )}
    </div>
  )
}
